import { Modal, ModalContent } from "semantic-ui-react";
import * as React from "react";
import "./image-modal.css";

export default function ImageModal({ thumbnailUrl, imageUrl, caption }: {
    thumbnailUrl: string;
    imageUrl: string;
    caption?: string;
}): JSX.Element {
    const [open, setOpen] = React.useState(false);

    return (
        <div className="imageModal">
            <Modal
                basic={true}
                open={open}
                size="large"
                trigger={
                    <div className="preview">
                        <img className="thumbnail" width="200" height="auto" src={thumbnailUrl} alt="Bild"/>
                        {caption !== undefined && <span className="caption">{caption}</span>}
                    </div>
                }
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                className="imageModal"
            >
                <ModalContent>
                    <img className="imageFull" src={imageUrl} alt="Bild"/>
                </ModalContent>
            </Modal>
        </div>
    );
}
